import { Injectable } from '@angular/core';
import { AccountFacade } from '@mode/accounts/contract';
import { LegacyAppStateStoreService } from '@mode/legacy/util-domain';
import { distinctUntilChanged, filter, map, withLatestFrom } from 'rxjs';
import { selectedDefinitionGithubState, selectedDefinitionQuery } from './selected-definition.selectors';

@Injectable()
export class DefinitionsFacade {
  githubContext$ = this.legacyStore.select(selectedDefinitionGithubState).pipe(
    distinctUntilChanged((previous, current) => {
      // The legacy store updates aren't very smart. We're getting noise here, so lets only update if something changes.
      return JSON.stringify(previous) === JSON.stringify(current);
    }),
    withLatestFrom(this.accountFacade.currentOrg$),
    map(([selectedContext, { username }]) => ({ ...selectedContext, workspace: username }))
  );

  definitionQuery$ = this.legacyStore.select(selectedDefinitionQuery).pipe(filter((x) => x !== null));

  constructor(
    private legacyStore: LegacyAppStateStoreService,
    private accountFacade: AccountFacade
  ) {}
}
